import { render, staticRenderFns } from "./TableSerial.vue?vue&type=template&id=1b015c1c"
import script from "./TableSerial.vue?vue&type=script&lang=js"
export * from "./TableSerial.vue?vue&type=script&lang=js"
import style0 from "./TableSerial.vue?vue&type=style&index=0&id=1b015c1c&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports